<template>
  <div>
    <div class="logo">
      <h1>Set Password</h1>
    </div>

    <form role="form">

      <div class="form-group-outer">
        <div class="form-group float-label-control form-group-email" :class="{ 'has-error': errors.has('email') }" >
          <label for="">Email/Mobile</label>
          <input
            type="email"
            class="form-control"
            :value="payload.email"
            v-validate="'required'"
            name="email"
            placeholder="Email/Mobile"
            disabled="disabled"
            v-float-label>
        </div>
      </div>

      <div class="form-group-outer">
        <div class="form-group float-label-control form-group-password" :class="{ 'has-error': errors.has('password') }" >
          <label for="">New Password</label>
          <input
            type="password"
            class="form-control"
            name="password"
            v-model="payload.password"
            placeholder="New Password"
            v-validate="'required|confirmed'"
            v-float-label>
        </div>
      </div>

      <div class="form-group-outer">
        <div class="form-group float-label-control form-group-password" :class="{ 'has-error': errors.has('password_confirmation') }" >
          <label for="">Repeat New Password</label>
          <input
            type="password"
            class="form-control"
            name="password_confirmation"
            v-model="payload.passwordConfirmation"
            placeholder="Repeat New Password"
            v-validate="'required'"
            v-float-label>
        </div>
      </div>

      <div class="text-right">
          <ladda-button :on-click="handlePasswordReset" type="success" button-type="submit">Set Password</ladda-button>
      </div>

      <div class="margin-20"></div>

    </form>
  </div>
</template>

<script>
  import { LaddaButton } from 'components/forms'
  import { mapActions } from 'vuex'
  import { auth, notify } from 'utils'
  import _ from 'lodash'

  export default {
    components: {
      LaddaButton
    },

    data () {
      return {
        payload: {
          email: null,
          token: null,
          password: null,
          passwordConfirmation: null,
          broker: null
        }
      }
    },

    created () {
      this.payload.email = this.$route.query.email
      this.payload.token = this.$route.query.token
      if (this.$route.query.broker) {
        this.payload.broker = this.$route.query.broker
      }
    },

    methods: {
      ...mapActions('user', ['resetPassword']),

      /**
       * Handle the reset of a password reset.
       *
       * @return Promise
       */
      handlePasswordReset () {
        return this.validateAll().then(() => {
          let payload = _.mapKeys(this.payload, (value, key) => _.snakeCase(key))

          const attemptAuthentication = () => {
            return auth.attempt(payload.email, payload.password)
              .then(() => {
                notify.success('Your password has been reset.')

                this.$router.push({ name: 'dashboard' })
              })
          }

          return this.resetPassword(payload).then(attemptAuthentication).catch(({ response }) => {
            // If server validation has failed then we'll spin through all the error keys and errors
            // for those keys to add the errors to our form.
            if (response.status === 422) {
              this.errors.clear()

              _.forIn(response.data.errors, (errors, key) => {
                this.errors.add(key, errors)
                notify.error(errors)
              })
            }
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PasswordForm.vue?d68603d6